// Shared form-field builders for the contact and referral screens. Each appends a
// labeled control to the form and returns the control element.

export interface TextFieldOptions {
  type?: string; // default "text"
  required?: boolean; // default false
  helpText?: string; // optional help paragraph rendered under the input
}

export function textField(
  form: HTMLFormElement,
  name: string,
  labelText: string,
  options: TextFieldOptions = {}
): HTMLInputElement {
  const group = document.createElement("div");
  group.className = "form-group";
  const label = document.createElement("label");
  label.htmlFor = `field-${name}`;
  label.textContent = labelText;
  const input = document.createElement("input");
  input.type = options.type ?? "text";
  input.name = name;
  input.id = `field-${name}`;
  if (options.required) input.required = true;
  group.appendChild(label);
  group.appendChild(input);
  if (options.helpText) {
    const help = document.createElement("p");
    help.className = "help-text field-help";
    help.textContent = options.helpText;
    group.appendChild(help);
  }
  form.appendChild(group);
  return input;
}

export function selectField(
  form: HTMLFormElement,
  name: string,
  labelText: string,
  options: { value: string; label: string }[]
): HTMLSelectElement {
  const group = document.createElement("div");
  group.className = "form-group";
  const label = document.createElement("label");
  label.htmlFor = `field-${name}`;
  label.textContent = labelText;
  const select = document.createElement("select");
  select.name = name;
  select.id = `field-${name}`;
  for (const opt of options) {
    const o = document.createElement("option");
    o.value = opt.value;
    o.textContent = opt.label;
    select.appendChild(o);
  }
  group.appendChild(label);
  group.appendChild(select);
  form.appendChild(group);
  return select;
}
